import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "code",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
    searchKey: "accounts.name",
  },
  {
    name: "parent_account_name",
    type: "text",
    sortable: true,
    searchable: true,
    searchKey: "parents.name",
  },
  {
    name: "active",
    type: "boolean",
    sortable: true,
    searchable: true,
  },
  {
    name: "notes",
    type: "text",
    sortable: true,
    searchable: true,
  },
];

export default function List() {
  return <ResourceListPage url="accounts" columns={columns} />;
}
